import * as React from 'react'
import { MenuTriangleDownSmall } from '@ds/icons'
import { Button, useIsInk } from '@ds/ui'
import { Locale } from '@ds/base'
import { useTranslate } from '@ds/comp-private'
import styles from './styles'

export interface FooterMenuTriggerButtonProps {
  text: string
  onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
  onKeyDown?: (event: React.KeyboardEvent<HTMLButtonElement>) => void
  forwardedRef?: React.RefObject<HTMLButtonElement>
  'data-qa': string
  currentLocale: Locale
}

/**
 * A button used as trigger to an ds/ui Menu
 */
export const FooterMenuTriggerButton: React.FunctionComponent<
  FooterMenuTriggerButtonProps
> = (props) => {
  const isInk = useIsInk()
  const translate = useTranslate()

  return isInk ? (
    <div css={styles.footerMenuTriggerInkButtonCSS}>
      <Button
        kind="tertiary"
        menuTrigger={true}
        onClick={props.onClick}
        onKeyDown={props.onKeyDown}
        forwardedRef={props.forwardedRef}
        aria-label={translate('FOOTER:LANGUAGE_SELECTOR:A11Y', {
          LANGUAGE: props.text,
        })}
        aria-haspopup="true"
        data-qa={props['data-qa']}
        size="small"
        text={props.text}
      />
    </div>
  ) : (
    <button
      type="button"
      css={styles.footerMenuTriggerButtonCSS}
      onClick={props.onClick}
      onKeyDown={props.onKeyDown}
      ref={props.forwardedRef}
      aria-label={translate('FOOTER:LANGUAGE_SELECTOR:A11Y', {
        LANGUAGE: props.text,
      })}
      aria-haspopup="true"
      data-qa={props['data-qa']}
    >
      <div>
        {props.text}
        <MenuTriangleDownSmall width={12} height={12} />
      </div>
    </button>
  )
}
